// extracted by mini-css-extract-plugin
export default {"menuSection":"menuSection---AaRgO","menuSection__label":"menuSection__label---x3Cb_"};